import React, { useEffect, useState, useRef } from "react";
import SimpleReactValidator from "simple-react-validator";
import QRCode from 'qrcode.react';
import { Controller, useForm } from "react-hook-form";
import { Hidden } from "react-awesome-styled-grid";
import AsYouType, { getCountryCallingCode } from "libphonenumber-js";
import SmallScreenView from "../../components/smallscreen";
import { COUNTRY_PHONE_CODE, INDIAN_STATES, EMAIL } from "../../appconstants";
import {
  addUpiPaymentsChargeById,
  payInvoiceById,
} from "../../api";
import {
  CancelButton,
  FlexContainer,
  H1Text,
  Hr,
  Input,
  InputWrapper,
  LabelText, SpanText,
  SubmitButton,
  PH3Text,
  UpiPanel,
  UpiPanel1,
  Text,
  Img,
  RoundButton,
} from "../../design";
import {
  SpError,
} from '../../widgetDesign';
import PaymentError from "../paymenterror";
import { ErrorMessage } from "@hookform/error-message";
import Select from "react-select";
import NumberFormat from "react-number-format";
import QRIcon from "../../assets/imgs/qr-img.svg";
import Arrow from "../../assets/imgs/qr-arrow.svg";
import Bhim from "../../assets/imgs/bhim.svg";
import Gpay from "../../assets/imgs/gpay.svg";
import Paytm from "../../assets/imgs/paytm.svg";
import PhonePay from "../../assets/imgs/phonepay.svg";
import User from "../../assets/imgs/paytm-user.svg";
import QrGpay from "../../assets/imgs/qr-gpay.svg";
import QrPaytm from "../../assets/imgs/qr-paytm.svg";
import QrPhonePay from "../../assets/imgs/qr-phonepay.svg";
import QrAmazon from "../../assets/imgs/qr-amazon.svg";
import IMobile from "../../assets/imgs/imobile.jpeg";
import { isValidPhoneNumber } from 'libphonenumber-js';
import ReCAPTCHA from 'react-google-recaptcha';
import { AmountDivideByHundred } from "../../helper";

type Props = {
  errorMsg: string,
  errorHeader: string,
  customerReadOnly: boolean,
  submit: Function,
  preFillCustomer: {
    name: string,
    email: string,
    phoneNumber: string,
  },
  customerFields: {
    name: string,
    contactUsEmail: string,
    contactUsPhone: string,
  },
  headerText: string,
  buttonText: string,
  customerValidation: boolean,
  alpha2: string,
  cancel: Function,
  getPaymentById: Function,
  showCancelBtn: boolean,
  cancelButtonText: string,
  paymentWidget: boolean,
  upiUrl: String,
  paymentMethodDetails: boolean,
  paymentPageDetails: boolean,
  showMobileViewUpi: boolean,
  paymentPagePay: boolean,
  invoicePay: boolean,
  hideQr: boolean,
  paymentPageMeta: string,
  currentCustomerGid: string,
  supportPhoneNumber: string,
  showWhatsAppNotify: Boolean,
  isCaptchaEnabled: Boolean,
  sitekey: String,
  paymentPageEntries: Array,
  account: Object,
  supportedPaymentTypes: Array,
  netAmount: Number,
  serviceFeeAmount: Number,
  totalPayableAmount: Number,
  serviceFeeEnabled: Boolean,
  prefix: string,
}

const UpiPayment = (props: Props) => {
  const { submit, preFillCustomer, paymentWidget, account, paymentPagePay, sitekey, isCaptchaEnabled, customerFields,
    headerText, buttonText, errorHeader, errorMsg, supportPhoneNumber, hideQr, showWhatsAppNotify, paymentPageEntries,
    customerReadOnly, customerValidation, supportedPaymentTypes, alpha2, showCancelBtn, cancel, cancelButtonText, upiUrl, getPaymentById, paymentMethodDetails, paymentPageDetails, paymentPageMeta, showMobileViewUpi, currentCustomerGid, invoicePay,
    netAmount, serviceFeeAmount, totalPayableAmount, serviceFeeEnabled, prefix } = props;

  const [isShowErrorMessage, setShowErrorMessage] = useState(false);
  const [showCancelButton, setShowCancelButton] = useState(showCancelBtn);
  const [customerReadOnlyList, setCustomerReadOnlyList] = useState([]);
  const [showQrCode, setShowQrCode] = useState(false);
  const [address, setAddress] = useState(null);
  const [loading, setLoading] = useState(false);
  const [hideUpiId, setHideUpiId] = useState(true);
  const [qrCodeText, setQRCodeText] = useState('');
  const [invalidQR, setInvalidQR] = useState(null);
  const [phoneNumber, setPhoneNumber] = useState(null);
  const [supportNumber, setSupportNumber] = useState(null);
  const [upiPayload, setUpiPayload] = useState('');
  const [upiId, setUpiId] = useState('');
  const [styleClass, setStyleClass] = useState('col-sm-6 pl-0');
  const [paymentSession, setPaymentSession] = useState('');
  const [psClientSecret, setPsClientSecret] = useState('');
  const [redirectionUri, setRedirectionUri] = useState('');
  const [recaptchaToken, setRecaptchToken] = useState(null);
  const [showCaptchError, setShowCaptchError] = useState(null);
  const [, forceUpdate] = useState();
  const simpleValidator = useRef(new SimpleReactValidator({
    validators: {
      validUpi: {
        message: 'The upi id is invalid',
        rule: val => (new RegExp(/^\w.+@\w+$/).exec(val) !== null),
      },
    },
  }));
  let apiInterval;
  const BACKGROUND_COLOR = '#E8ECED';
  const COLOR = '#6A6A6A';

  useEffect(() => {
    setShowCancelButton(showCancelBtn);
  }, [showCancelBtn]);

  useEffect(() => {
    if (paymentWidget) {
      setStyleClass('col-sm-12 pl-0');
    }
  }, [paymentWidget]);

  const {
    control,
    handleSubmit,
    errors,
    reset,
    setValue,
  } = useForm();

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setValue('notify', checked);
  }, [checked]);

  useEffect(() => {
    if (preFillCustomer) {
      const phone = preFillCustomer && preFillCustomer.phoneNumber && AsYouType(preFillCustomer.phoneNumber);
      setPhoneNumber(phone && phone.nationalNumber);
      const upiSupportPhone = supportPhoneNumber && AsYouType(supportPhoneNumber);
      setSupportNumber(upiSupportPhone && upiSupportPhone.nationalNumber);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      const address = preFillCustomer && preFillCustomer.billingAddress;
      setAddress(address);
      setUpiPayload({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
        address: address && address.street,
        city: address && address.city,
        postalCode: address && address.postalCode,
        state: address && findStateByCode(address.state),
      });
      reset({
        name: preFillCustomer && preFillCustomer.name || "",
        email: preFillCustomer && preFillCustomer.email || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
        address: address && address.street,
        city: address && address.city,
        postalCode: address && address.postalCode,
        state: address && findStateByCode(address.state),
      })
    }
  }, [reset, preFillCustomer]);

  useEffect(() => {
    if (paymentPagePay) {
      const phone = customerFields && customerFields.contactUsPhone && AsYouType(customerFields.contactUsPhone);
      const countryCallingCode = phone && `+${phone.countryCallingCode}` || alpha2 && `+${getCountryCallingCode(alpha2)}`;
      reset({
        cname: customerFields && customerFields.name || "",
        email: customerFields && customerFields.contactUsEmail || "",
        phone: phone && phone.nationalNumber || "",
        countryCallingCode: countryCallingCode && findCountryCallingCode(countryCallingCode) || "",
      })
    }
  }, [reset, customerFields])

  useEffect(() => {
    if (errorMsg) {
      setShowErrorMessage(true);
    } else setShowErrorMessage(false);
  }, [errorMsg]);

  const findCountryCallingCode = (value) => (
    value && COUNTRY_PHONE_CODE.includes(value) && { value }
  );

  const findStateByCode = (code) => (
    INDIAN_STATES.find(value => value.code === code)
  );

  useEffect(() => {
    setCustomerReadOnlyList([]);
    if (customerReadOnly) {
      setCustomerReadOnlyList(['name', 'email', 'phone']);
    }
  }, [props.customerReadOnly]);

  const customStyles = {
    control: base => ({
      ...base,
      height: 33,
      minHeight: 33,
      border: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important',
      marginTop: "8px"
    }),
    dropdownIndicator: base => ({
      ...base,
      height: 33,
      minHeight: 33,
    })
  };

  const phoneCustomStyles = {
    control: base => ({
      ...base,
      height: 33,
      minHeight: 33,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important'
    }),
  };

  const disableStyles = {
    control: base => ({
      ...base,
      height: 33,
      minHeight: 33,
      border: 'none',
      borderRight: '1px solid #29B1CC',
      boxShadow: 'none',
      borderColor: '#29B1CC !important',
      background: '#E8ECED',
      color: '#6A6A6A'
    }),
  };

  const onSubmit = data => {
    if (recaptchaToken) {
      setShowCaptchError(null);
    } else {
      setShowCaptchError('Captcha is required');
    }
    const { name, email, vpa, phone, countryCallingCode, notify, } = data;
    const phoneNumber = countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}`;
    const customer = { name, email, phoneNumber };
    const paymentMethod = { type: "UPI", upi: { vpa } };
    const finalData = { ...data, phoneNumber, notify, customer, paymentMethod, recaptchaToken };
    if (isCaptchaEnabled) {
      if (recaptchaToken) {
        if (submit) { submit(finalData); }
      }
    } else {
      if (submit) { submit(finalData); }
    }
  };

  useEffect(() => {
    if (!hideUpiId) {
      const interval = setInterval(() => {
        getPaymentById(paymentSession, psClientSecret, redirectionUri);
      }, 10000);
      return () => clearInterval(interval);
    }
  }, [hideUpiId]);

  const updateUpiID = data => {
    let upiNum;
    if (phoneNumber) {
      upiNum = phoneNumber;
    } else {
      upiNum = supportNumber;
    }
    if (data === 'gpay') {
      setUpiId(upiNum || '');
    } else if (data === 'paytm') {
      setUpiId(upiNum ? `${upiNum}@paytm` : '');
    } else if (data === 'phonepay') {
      setUpiId(upiNum ? `${upiNum}@ybl` : '');
    } else if (data === 'amazon') {
      setUpiId(upiNum ? `${upiNum}@apl` : '');
    } else setUpiId(upiNum);
  }

  const isPhoneNumberValidate = (data: string) => {
    const cuntryCode = control.getValues().countryCallingCode.value;
    const phoneNum = control.getValues().phone;
    if (!isValidPhoneNumber(`${cuntryCode}${phoneNum}`)) {
      return 'The phone number is invalid';
    }
  };


  const onUpiSubmit = (event) => {
    event.preventDefault();
    const formValid = simpleValidator.current.allValid();
    setShowErrorMessage(false);
    if (!formValid) {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      return;
    }
    const { name, email, phone, countryCallingCode, notify } = upiPayload;
    const phoneNumber = phone ? countryCallingCode && countryCallingCode.value && `${countryCallingCode.value}${phone}` : supportPhoneNumber;
    const customer = { name, email, phoneNumber };
    const paymentMethod = { type: "UPI", upi: { vpa: upiId } };
    const finalData = { ...upiPayload, phoneNumber, customer, notify, paymentMethod };
    submit(finalData);
  };

  const onClickQrCode = async (data) => {
    if (data === 'prev') {
      clearInterval(apiInterval);
      setHideUpiId(true);
    } else {
      setLoading(true);
      let data;
      if (paymentMethodDetails === true) {
        data = {
          "paymentMethodDetails": {
            "subType": "QR",
            "type": "UPI"
          },
        }
      } else if (invoicePay === true) {
        data = {
          "paymentMethod": {
            "subType": "QR",
            "type": "UPI",
            "customerGid": currentCustomerGid,
          },
        }
      } else if (paymentPagePay === true) {
        const coustomer = {
          name: account && account.name,
          email: customerFields.contactUsEmail,
          phoneNumber: customerFields.contactUsPhone,
        };
        data = {
          "paymentMethodType": [
            "UPI"
          ],
          "paymentMethodDetails": {
            "type": "UPI",
            "subType": "QR"
          },
          paymentPageEntries,
          customerDetails: coustomer,
          "paymentPageMetaGid": paymentPageMeta.gid,
          "shouldWhatsAppNotify": false,
        }
      } else {
        data = {
          "paymentMethod": {
            "subType": "QR",
            "type": "UPI"
          },
        }
      }
      try {
        let value;
        if (invoicePay === true) {
          value = await payInvoiceById(upiUrl, data);
          if (value && value.nextActionUrl) {
            const { nextActionUrl } = value;
            if (nextActionUrl) {
              window.location = nextActionUrl;
              return;
            }
          }
          if (value && value.paymentSession) {
            setPaymentSession(value.paymentSession.gid || null);
            setPsClientSecret(value.paymentSession.psClientSecret || null);
            setRedirectionUri(value.redirectUri || null);
            setQRCodeText(value.paymentSession.qrUrl);
            setLoading(false);
            setHideUpiId(false);
          }
        } else {
          value = await addUpiPaymentsChargeById(upiUrl, data);
          if (value && value.nextActionUrl) {
            const { nextActionUrl } = value;
            if (nextActionUrl) {
              window.location = nextActionUrl;
              return;
            }
          }
          if (value && value.qrUrl) {
            setPaymentSession(value.paymentSessionGid || null);
            setPsClientSecret(value.psClientSecret || null);
            setRedirectionUri(value.redirectUri || null);
            setQRCodeText(value.qrUrl);
            setLoading(false);
            setHideUpiId(false);
          }
        }

      } catch (err) {
        setLoading(false);
        setHideUpiId(true);
        setInvalidQR('QR is not supported for this payment')
        setShowErrorMessage(true);
      }
    }
  };

  const onCancel = () => { showCancelButton && cancel && cancel(); };

  return (
    <>
      <H1Text
        className="px-1 px-md-4 mb-0"
      >
        <SmallScreenView>
          {"Pay With UPI ID"}
        </SmallScreenView>
        <Hidden sm xs>
          {headerText || "Pay With UPI"}
        </Hidden>
      </H1Text>
      {
        (showMobileViewUpi) ? (
          <>
            <SmallScreenView>
              <RoundButton
                className="ml-2 mr-2"
                onClick={() =>
                  updateUpiID('imobile')
                }
              >
                <img
                  src={IMobile}
                  alt="IMobile"
                  width="20"
                />

              </RoundButton>
              <RoundButton
                className="ml-2 mr-2"
                onClick={() =>
                  updateUpiID('gpay')
                }
              >
                <img
                  src={QrGpay}
                  alt="Gpay"
                />
              </RoundButton>
              <RoundButton
                className="ml-2 mr-2"
                onClick={() =>
                  updateUpiID('paytm')
                }
              >
                <img
                  src={QrPaytm}
                  alt="Paytm"
                />
              </RoundButton>
              <RoundButton
                className="ml-2 mr-2"
                onClick={() =>
                  updateUpiID('phonepay')
                }
              >
                <img
                  src={QrPhonePay}
                  alt="Phonepay"
                />
              </RoundButton>
              <RoundButton
                className="ml-2 mr-2"
                onClick={() =>
                  updateUpiID('amazon')
                }
              >
                <img
                  src={QrAmazon}
                  alt="Amazon"
                />
              </RoundButton>
              <div className="mt-2 ml-1 w-50">
                <Input
                  placeholder="Enter your Upi ID"
                  style={{ border: '1px solid #9A9A9A' }}
                  value={upiId}
                  onChange={(e) => setUpiId(e.currentTarget.value)}
                />
              </div>
              <div className="ml-1 mt-1">
                <SpError>
                  {simpleValidator.current.message('upiId', upiId, 'required|validUpi')}
                </SpError>
              </div>
              <Hr />
              <div className="px-1 px-md-4">
                <FlexContainer
                  width="100%"
                  justifyContent="space-between"
                >
                  <SubmitButton
                    type="submit"
                    onClick={onUpiSubmit}
                    className="ml-5"
                  >{buttonText || "PAY"}</SubmitButton>
                </FlexContainer>
                <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#484848">
                  *No fees applicable for UPI/QR payments
                </Text>
                {isShowErrorMessage && <PaymentError header={invalidQR || errorHeader} message={errorMsg} />}
              </div>
            </SmallScreenView>
            <Hidden sm xs>
              <form
                hidden={showQrCode}
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSubmit(onSubmit)(e);
                }}
                onChange={() => setShowErrorMessage(false)}
                style={{
                  width: '100%',
                }}
              >
                {

                  loading ? (
                    <>
                      <div style={{ marginLeft: '150px' }} className="spinner-border text-muted mr-4"> </div>
                    </>
                  ) : (
                    <FlexContainer
                      flexDirection="column"
                    >
                      {
                        hideUpiId ? (
                          <>
                            <div className="px-1 px-md-4 mt-2 w-100">
                              <div className="row m-0">
                                <div className={styleClass}>
                                  <LabelText>
                                    UPI Id
                                  </LabelText>
                                  <Controller
                                    defaultValue={""}
                                    color={errors.vpa ? "red" : "inherit"}
                                    marginBottom="0px"
                                    control={control}
                                    name="vpa"
                                    placeholder="Enter your upi id"
                                    rules={{
                                      required: 'This field is required',
                                      pattern: {
                                        value: /^\w.+@\w+$/,
                                        message: 'The upi id is invalid',
                                      },
                                    }}
                                    as={<Input className="w-100" />}
                                  />
                                  <ErrorMessage
                                    errors={errors}
                                    name="vpa"
                                    render={({ message }) => (
                                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row m-0">
                                <div className={styleClass}>
                                  <LabelText>
                                    Name
                                  </LabelText>
                                  <Controller
                                    defaultValue={""}
                                    color={errors.name ? "red" : "inherit"}
                                    marginBottom="0px"
                                    control={control}
                                    name="name"
                                    placeholder="Enter your name"
                                    rules={customerValidation && {
                                      required: 'This field is required'
                                    }}
                                    as={<Input
                                      className="w-100"
                                      readOnly={customerReadOnlyList && customerReadOnlyList.includes("name")}
                                      style={{
                                        background: (customerReadOnlyList && customerReadOnlyList.includes("name")) ? BACKGROUND_COLOR : '',
                                        color: (customerReadOnlyList && customerReadOnlyList.includes("name")) ? COLOR : ''
                                      }}
                                    />}
                                  />
                                  <ErrorMessage
                                    errors={errors}
                                    name="name"
                                    render={({ message }) => (
                                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row m-0">
                                <div className={styleClass}>
                                  <LabelText>
                                    Email
                                  </LabelText>
                                  <Controller
                                    marginBottom="0px"
                                    defaultValue={""}
                                    color={errors.email ? "red" : "inherit"}
                                    control={control}
                                    name="email"
                                    placeholder="Enter your email address"
                                    rules={customerValidation && {
                                      required: 'This filed is required',
                                      pattern: {
                                        value: EMAIL.DEFAULT_REGEX,
                                        message: 'The email is invalid',
                                      },
                                    }}
                                    as={<Input
                                      className="w-100"
                                      readOnly={customerReadOnlyList && customerReadOnlyList.includes("email")} />}
                                    style={{
                                      background: (customerReadOnlyList && customerReadOnlyList.includes("email")) ? BACKGROUND_COLOR : '',
                                      color: (customerReadOnlyList && customerReadOnlyList.includes("email")) ? COLOR : ''
                                    }}
                                  />
                                  <ErrorMessage
                                    errors={errors}
                                    name="email"
                                    render={({ message }) => (
                                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                  />
                                </div>
                              </div>
                              <div className="row m-0">
                                <div className={styleClass}>
                                  <LabelText>
                                    Phone
                                  </LabelText>
                                  <InputWrapper className="row" display="flex" marginTop="8px" borderRadius="4px" width='100%'>
                                    <Controller
                                      defaultValue={""}
                                      color={errors.countryCallingCode ? "red" : "inherit"}
                                      marginBottom="0px"
                                      control={control}
                                      name="countryCallingCode"
                                      placeholder="select"
                                      rules={customerValidation && {
                                        required: 'Calling Code is required'
                                      }}
                                      as={<Select
                                        className="col-4 px-0 border-0"
                                        menuPlacement="auto"
                                        isSearchable={!customerReadOnlyList && customerReadOnlyList.includes("phone")}
                                        menuIsOpen={customerReadOnlyList && customerReadOnlyList.includes("phone") ? false : undefined}
                                        theme={theme => ({
                                          ...theme,
                                          borderRadius: "4px 0 0 4px",
                                          boxShadow: 0
                                        })}
                                        getOptionLabel={(option) => option.value}
                                        styles={customerReadOnlyList && customerReadOnlyList.includes("phone") ? disableStyles : phoneCustomStyles}
                                        options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
                                    />
                                    <Controller
                                      className="col"
                                      defaultValue={""}
                                      color={errors.phone ? "red" : "inherit"}
                                      border="0px !important"
                                      marginBottom="0px"
                                      marginTop="0px"
                                      marginLeft="0px"
                                      paddingRight="0"
                                      control={control}
                                      name="phone"
                                      rules={customerValidation && {
                                        required: 'This filed is required',
                                        validate: isPhoneNumberValidate
                                      }}
                                      as={<Input
                                        type='tel'
                                        minLength={6}
                                        maxLength={10}
                                        readOnly={customerReadOnlyList && customerReadOnlyList.includes("phone")}
                                      />}
                                      placeholder="Enter your phone number"
                                      style={{
                                        background: (customerReadOnlyList && customerReadOnlyList.includes("phone")) ? BACKGROUND_COLOR : '',
                                        color: (customerReadOnlyList && customerReadOnlyList.includes("phone")) ? COLOR : ''
                                      }}
                                      customInput={Input}
                                    />
                                  </InputWrapper>
                                  <ErrorMessage
                                    errors={errors}
                                    name="phone"
                                    render={({ message }) => (
                                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                    )}
                                  />
                                </div>
                              </div>
                              {
                                showWhatsAppNotify && (
                                  <div className="row ml-1 mt-3">
                                    <label>
                                      <Controller
                                        marginBottom="0px" name='notify' control={control} as={<Input type="checkbox"
                                          defaultChecked={checked}
                                          onClick={({ target }) => setChecked(target.checked)} width="auto" />} />
                                      <SpanText className="pl-2">Notify on whatsapp</SpanText></label>
                                  </div>
                                )
                              }
                              {
                                sitekey && (isCaptchaEnabled === true) && (
                                  <div className="mt-3">
                                    <ReCAPTCHA
                                      sitekey={sitekey}
                                      value={recaptchaToken}
                                      onChange={(value) => {
                                        setRecaptchToken(value);
                                        setShowCaptchError(null);
                                      }}
                                    />
                                    {
                                      (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                                      ) : showCaptchError ? (
                                        <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                                      ) : ''
                                    }
                                  </div>
                                )
                              }
                            </div>
                            {
                              !hideQr && (
                                <>
                                  {
                                    supportedPaymentTypes && supportedPaymentTypes.includes('QR') && !(navigator.userAgent.match(/Android/i)) ? (
                                      <>
                                        <Hr />
                                        <div className="px-1 px-md-4 mt-4 mb-4 w-100">
                                          <div className="row m-0">
                                            <div
                                              onClick={() => onClickQrCode('next')}
                                              className={styleClass}>
                                              <UpiPanel>
                                                <Img
                                                  style={{
                                                    marginTop: '19px',
                                                    marginLeft: '16px',
                                                  }}
                                                  src={QRIcon}
                                                />
                                                <PH3Text>Show QR</PH3Text>
                                                <PH3Text
                                                  marginTop='5px'
                                                  fontSize='11px'
                                                  color='#848484'
                                                >
                                                  Scan the QR code using your UPI app
                                                </PH3Text>
                                                <p
                                                  style={{
                                                    marginLeft: '90%',
                                                    marginTop: '-19px',
                                                  }}
                                                >
                                                  <Img
                                                    src={Arrow}
                                                  />
                                                </p>
                                              </UpiPanel>
                                            </div>
                                          </div>
                                        </div>
                                        <Hr />
                                      </>
                                    ) : null
                                  }

                                </>
                              )
                            }
                            {
                              (serviceFeeEnabled === true) && (
                                <div className="px-1 px-md-4">
                                  <div class="mt-4">
                                    <table class="table table-bordered mt-4">
                                      <tbody>
                                        <tr style={{ borderBottom: 'hidden' }}>
                                          <th scope="row">Amount:</th>
                                          <td>{prefix} {AmountDivideByHundred(netAmount)}</td>
                                        </tr>
                                        <tr style={{ borderBottom: 'hidden' }}>
                                          <th scope="row">Service Fee:</th>
                                          <td>{prefix} {AmountDivideByHundred(serviceFeeAmount)}</td>
                                        </tr>
                                        <tr style={{ background: '#F7F7F7' }}>
                                          <th scope="row">Total Payable:</th>
                                          <td class="font-weight-bold">{prefix} {AmountDivideByHundred(totalPayableAmount)}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )
                            }
                            <div className="px-1 px-md-4">
                              <FlexContainer
                                width="100%"
                                alignItems="center"
                                justifyContent="space-between"
                              >
                                {
                                  showCancelButton && cancel &&
                                  <SpanText
                                    onClick={onCancel}
                                    cursor="pointer"
                                    color="#40A9FF"
                                    className="cursor-pointer mr-5 pt-3"
                                  >{cancelButtonText || "Cancel"}</SpanText>
                                }
                                <SubmitButton
                                  type="submit"
                                  className="ml-5"
                                >{buttonText || "PAY"}</SubmitButton>
                              </FlexContainer>
                              {isShowErrorMessage && <PaymentError header={errorHeader} message={invalidQR || errorMsg} />}
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="px-1 px-md-4 mt-4 mb-4 w-100">
                              <div className="row m-0">
                                <div
                                  onClick={() => onClickQrCode('prev')}
                                  className={styleClass}>
                                  <UpiPanel>
                                    <Img
                                      style={{
                                        marginTop: '19px',
                                        marginLeft: '16px',
                                      }}
                                      src={User}
                                    />
                                    <PH3Text>UPI ID</PH3Text>
                                    <PH3Text
                                      marginTop='5px'
                                      fontSize='11px'
                                      color='#848484'
                                    >
                                      Use your UPI Id
                                    </PH3Text>
                                    <p
                                      style={{
                                        marginLeft: '90%',
                                        marginTop: '-19px',
                                      }}
                                    >
                                      <Img
                                        src={Arrow}
                                      />
                                    </p>
                                  </UpiPanel>
                                </div>
                              </div>
                            </div>
                            <Hr />
                            <div className="px-1 px-md-4 mt-2 mb-4 w-100">
                              <div className="row m-0">
                                <div className={styleClass}>
                                  <H1Text className="mt-4">
                                    PAY USING QR CODE
                                  </H1Text>
                                  <UpiPanel1>
                                    <PH3Text
                                      marginTop='40px'
                                      marginLeft='35px'
                                      fontSize='11px'
                                      color='#848484'
                                    >
                                      Scan the QR using any UPI app on your phone
                                    </PH3Text>
                                    <PH3Text
                                      marginTop='5px'
                                      marginLeft='40px'
                                      fontSize='11px'
                                      color='#848484'
                                    >
                                      like BHIM, PhonePe, Google Pay etc.
                                    </PH3Text>
                                    <div
                                      style={{
                                        marginTop: '15px',
                                        marginLeft: '55px',
                                      }}
                                    >
                                      <Img
                                        src={Bhim}
                                        marginRight='15px'
                                      />
                                      <Img
                                        src={PhonePay}
                                        marginRight='15px'
                                      />
                                      <Img
                                        src={Gpay}
                                        marginRight='15px'
                                      />
                                      <Img
                                        src={Paytm}
                                        marginRight='15px'
                                      />
                                    </div>
                                    <div
                                      style={{
                                        marginTop: '40px',
                                        marginLeft: '20%',
                                      }}
                                    >
                                      <QRCode
                                        id="qrCodeEl"
                                        size={160}
                                        value={qrCodeText}
                                      />
                                    </div>
                                  </UpiPanel1>
                                </div>
                              </div>
                            </div>
                          </>
                        )
                      }
                    </FlexContainer>
                  )
                }
              </form>
            </Hidden>
          </>
        ) : (
          <>
            <form
              hidden={showQrCode}
              onSubmit={(e) => {
                e.preventDefault();
                handleSubmit(onSubmit)(e);
              }}
              onChange={() => setShowErrorMessage(false)}
              style={{
                width: '100%',
              }}
            >
              {

                loading ? (
                  <>
                    <div style={{ marginLeft: '150px' }} className="spinner-border text-muted mr-4"> </div>
                  </>
                ) : (
                  <FlexContainer
                    flexDirection="column"
                  >
                    {
                      hideUpiId ? (
                        <>
                          <div className="px-1 px-md-4 mt-2 w-100">
                            <div className="row m-0">
                              <div className={styleClass}>
                                <LabelText>
                                  UPI Id
                                </LabelText>
                                <Controller
                                  defaultValue={""}
                                  color={errors.vpa ? "red" : "inherit"}
                                  marginBottom="0px"
                                  control={control}
                                  name="vpa"
                                  placeholder="Enter your upi id"
                                  rules={{
                                    required: 'This field is required',
                                    pattern: {
                                      value: /^\w.+@\w+$/,
                                      message: 'The upi id is invalid',
                                    },
                                  }}
                                  as={<Input className="w-100" />}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="vpa"
                                  render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="row m-0">
                              <div className={styleClass}>
                                <LabelText>
                                  Name
                                </LabelText>
                                <Controller
                                  defaultValue={""}
                                  color={errors.name ? "red" : "inherit"}
                                  marginBottom="0px"
                                  control={control}
                                  name="name"
                                  placeholder="Enter your name"
                                  rules={customerValidation && {
                                    required: 'This field is required'
                                  }}
                                  as={<Input
                                    className="w-100"
                                    readOnly={customerReadOnlyList && customerReadOnlyList.includes("name")}
                                    style={{
                                      background: (customerReadOnlyList && customerReadOnlyList.includes("name")) ? BACKGROUND_COLOR : '',
                                      color: (customerReadOnlyList && customerReadOnlyList.includes("name")) ? COLOR : ''
                                    }}
                                  />}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="name"
                                  render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="row m-0">
                              <div className={styleClass}>
                                <LabelText>
                                  Email
                                </LabelText>
                                <Controller
                                  marginBottom="0px"
                                  defaultValue={""}
                                  color={errors.email ? "red" : "inherit"}
                                  control={control}
                                  name="email"
                                  placeholder="Enter your email address"
                                  rules={customerValidation && {
                                    required: 'This filed is required',
                                    pattern: {
                                      value: EMAIL.DEFAULT_REGEX,
                                      message: 'The email is invalid',
                                    },
                                  }}
                                  as={<Input
                                    className="w-100"
                                    readOnly={customerReadOnlyList && customerReadOnlyList.includes("email")} />}
                                  style={{
                                    background: (customerReadOnlyList && customerReadOnlyList.includes("email")) ? BACKGROUND_COLOR : '',
                                    color: (customerReadOnlyList && customerReadOnlyList.includes("email")) ? COLOR : ''
                                  }}
                                />
                                <ErrorMessage
                                  errors={errors}
                                  name="email"
                                  render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                  )}
                                />
                              </div>
                            </div>
                            <div className="row m-0">
                              <div className={styleClass}>
                                <LabelText>
                                  Phone
                                </LabelText>
                                <InputWrapper className="row" display="flex" marginTop="8px" borderRadius="4px" width='100%'>
                                  <Controller
                                    defaultValue={""}
                                    color={errors.countryCallingCode ? "red" : "inherit"}
                                    marginBottom="0px"
                                    control={control}
                                    name="countryCallingCode"
                                    placeholder="select"
                                    rules={customerValidation && {
                                      required: 'Calling Code is required'
                                    }}
                                    as={<Select
                                      className="col-4 px-0 border-0"
                                      menuPlacement="auto"
                                      isSearchable={!customerReadOnlyList && customerReadOnlyList.includes("phone")}
                                      menuIsOpen={customerReadOnlyList && customerReadOnlyList.includes("phone") ? false : undefined}
                                      theme={theme => ({
                                        ...theme,
                                        borderRadius: "4px 0 0 4px",
                                        boxShadow: 0
                                      })}
                                      getOptionLabel={(option) => option.value}
                                      styles={customerReadOnlyList && customerReadOnlyList.includes("phone") ? disableStyles : phoneCustomStyles}
                                      options={COUNTRY_PHONE_CODE.map(value => { return { value } })} />}
                                  />
                                  <Controller
                                    className="col"
                                    defaultValue={""}
                                    color={errors.phone ? "red" : "inherit"}
                                    border="0px !important"
                                    marginBottom="0px"
                                    marginTop="0px"
                                    marginLeft="0px"
                                    paddingRight="0"
                                    control={control}
                                    name="phone"
                                    rules={customerValidation && {
                                      required: 'This filed is required',
                                      pattern: {
                                        value: /^\d{6,12}$/,
                                        message: 'The phone number is invalid',
                                      },
                                    }}
                                    as={<Input type='tel' maxLength="12" readOnly={customerReadOnlyList && customerReadOnlyList.includes("phone")} />}
                                    placeholder="Enter your phone number"
                                    style={{
                                      background: (customerReadOnlyList && customerReadOnlyList.includes("phone")) ? BACKGROUND_COLOR : '',
                                      color: (customerReadOnlyList && customerReadOnlyList.includes("phone")) ? COLOR : ''
                                    }}
                                    customInput={Input}
                                  />
                                </InputWrapper>
                                <ErrorMessage
                                  errors={errors}
                                  name="phone"
                                  render={({ message }) => (
                                    <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{message}</Text>
                                  )}
                                />
                              </div>
                            </div>
                            {
                              showWhatsAppNotify && (
                                <div className="row ml-1 mt-3">
                                  <label>
                                    <Controller
                                      marginBottom="0px" name='notify' control={control} as={<Input type="checkbox"
                                        defaultChecked={checked}
                                        onClick={({ target }) => setChecked(target.checked)} width="auto" />} />
                                    <SpanText className="pl-2">Notify on whatsapp</SpanText></label>
                                </div>
                              )
                            }
                            {
                              sitekey && (isCaptchaEnabled === true) && (
                                <div className="mt-3">
                                  <ReCAPTCHA
                                    sitekey={sitekey}
                                    value={recaptchaToken}
                                    onChange={(value) => {
                                      setRecaptchToken(value);
                                      setShowCaptchError(null);
                                    }}
                                  />
                                  {
                                    (Object.keys(errors).length > 0) && (!recaptchaToken) ? (
                                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">Captcha is required</Text>
                                    ) : showCaptchError ? (
                                      <Text fontSize="12px" marginTop="4px" marginBottom="0px" color="#ff1e1e">{showCaptchError}</Text>
                                    ) : ''
                                  }
                                </div>
                              )
                            }
                          </div>
                          {
                            !hideQr && (
                              <>
                                {

                                  supportedPaymentTypes && supportedPaymentTypes.includes('QR') && !(navigator.userAgent.match(/Android/i)) ? (
                                    <>
                                      <Hr />
                                      <div className="px-1 px-md-4 mt-4 mb-4 w-100">
                                        <div className="row m-0">
                                          <div
                                            onClick={() => onClickQrCode('next')}
                                            className={styleClass}>
                                            <UpiPanel>
                                              <Img
                                                style={{
                                                  marginTop: '19px',
                                                  marginLeft: '16px',
                                                }}
                                                src={QRIcon}
                                              />
                                              <PH3Text>Show QR</PH3Text>
                                              <PH3Text
                                                marginTop='5px'
                                                fontSize='11px'
                                                color='#848484'
                                              >
                                                Scan the QR code using your UPI app
                                              </PH3Text>
                                              <p
                                                style={{
                                                  marginLeft: '90%',
                                                  marginTop: '-19px',
                                                }}
                                              >
                                                <Img
                                                  src={Arrow}
                                                />
                                              </p>
                                            </UpiPanel>
                                          </div>
                                        </div>
                                      </div>
                                      <Hr />
                                    </>
                                  ) : null
                                }
                              </>
                            )
                          }
                          <div className="px-1 px-md-4">
                            <FlexContainer
                              width="100%"
                              alignItems="center"
                              justifyContent="space-between"
                            >
                              {
                                showCancelButton && cancel &&
                                <SpanText
                                  onClick={onCancel}
                                  cursor="pointer"
                                  color="#40A9FF"
                                  className="cursor-pointer mr-5 pt-3"
                                >{cancelButtonText || "Cancel"}</SpanText>
                              }
                              <SubmitButton
                                type="submit"
                                className="ml-5"
                              >{buttonText || "PAY"}</SubmitButton>
                            </FlexContainer>
                            {isShowErrorMessage && <PaymentError header={errorHeader} message={invalidQR || errorMsg} />}
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="px-1 px-md-4 mt-4 mb-4 w-100">
                            <div className="row m-0">
                              <div
                                onClick={() => onClickQrCode('prev')}
                                className={styleClass}>
                                <UpiPanel>
                                  <Img
                                    style={{
                                      marginTop: '19px',
                                      marginLeft: '16px',
                                    }}
                                    src={User}
                                  />
                                  <PH3Text>UPI ID</PH3Text>
                                  <PH3Text
                                    marginTop='5px'
                                    fontSize='11px'
                                    color='#848484'
                                  >
                                    Use your UPI Id
                                  </PH3Text>
                                  <p
                                    style={{
                                      marginLeft: '90%',
                                      marginTop: '-19px',
                                    }}
                                  >
                                    <Img
                                      src={Arrow}
                                    />
                                  </p>
                                </UpiPanel>
                              </div>
                            </div>
                          </div>
                          <Hr />
                          <div className="px-1 px-md-4 mt-2 mb-4 w-100">
                            <div className="row m-0">
                              <div className={styleClass}>
                                <H1Text className="mt-4">
                                  PAY USING QR CODE
                                </H1Text>
                                <UpiPanel1>
                                  <PH3Text
                                    marginTop='40px'
                                    marginLeft='35px'
                                    fontSize='11px'
                                    color='#848484'
                                  >
                                    Scan the QR using any UPI app on your phone
                                  </PH3Text>
                                  <PH3Text
                                    marginTop='5px'
                                    marginLeft='40px'
                                    fontSize='11px'
                                    color='#848484'
                                  >
                                    like BHIM, PhonePe, Google Pay etc.
                                  </PH3Text>
                                  <div
                                    style={{
                                      marginTop: '15px',
                                      marginLeft: '55px',
                                    }}
                                  >
                                    <Img
                                      src={Bhim}
                                      marginRight='15px'
                                    />
                                    <Img
                                      src={PhonePay}
                                      marginRight='15px'
                                    />
                                    <Img
                                      src={Gpay}
                                      marginRight='15px'
                                    />
                                    <Img
                                      src={Paytm}
                                      marginRight='15px'
                                    />
                                  </div>
                                  <div
                                    style={{
                                      marginTop: '40px',
                                      marginLeft: '20%',
                                    }}
                                  >
                                    <QRCode
                                      id="qrCodeEl"
                                      size={160}
                                      value={qrCodeText}
                                    />
                                  </div>
                                </UpiPanel1>
                              </div>
                            </div>
                          </div>
                        </>
                      )
                    }
                  </FlexContainer>
                )
              }
            </form>
          </>
        )
      }
    </>
  )
};

export default UpiPayment;
